import { render, staticRenderFns } from "./MarketGalleryCard.vue?vue&type=template&id=7000aef6&scoped=true"
import script from "./MarketGalleryCard.vue?vue&type=script&lang=js"
export * from "./MarketGalleryCard.vue?vue&type=script&lang=js"
import style0 from "./MarketGalleryCard.vue?vue&type=style&index=0&id=7000aef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7000aef6",
  null
  
)

export default component.exports